import { render, staticRenderFns } from "./OrderHistoryList.vue?vue&type=template&id=a6bf20b4&scoped=true&"
import script from "./OrderHistoryList.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryList.vue?vue&type=style&index=0&id=a6bf20b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf20b4",
  null
  
)

export default component.exports